import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import axios from 'axios'  
import VueAxios from 'vue-axios'
import VuetifyConfirm from 'vuetify-confirm'
import VueI18n from 'vue-i18n'
import messages from './lang'

Vue.use(VueAxios, axios)
Vue.use(VuetifyConfirm, { vuetify })
Vue.use(VueI18n)
const token = localStorage.getItem('token')
const authType = localStorage.getItem('authType')
//const organizationId = localStorage.getItem('organizationId')
Vue.config.productionTip = false

if(authType == 'AD')
  axios.defaults.withCredentials = true

axios.defaults.baseURL = '/api/' //produkcija
//axios.defaults.baseURL = 'https://localhost:5001/';//local staging  

if(token && authType == 'DB')
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token

//if(organizationId){
//  axios.defaults.headers.common['Organization'] = organizationId
//}

export const i18n = new VueI18n({
  locale: 'eng',
  fallbackLocale: 'eng',
  messages
})

axios.interceptors.response.use(
  function (response) {
    return Promise.resolve(response);
  }, 
  function (error) {
  if (error) {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
  
        originalRequest._retry = true;
        if(authType == 'DB') {
          store.dispatch('logout');
          return router.push('/login');
        } 
    }
    return Promise.reject(error);
  }
})


fetch(process.env.BASE_URL + "config.json")
.then((response) => response.json())
.then((config) => {
     Vue.prototype.$config = config
     new Vue({
      icons: {
        iconfont: 'md',
      },
      vuetify,
      router,
      store,
      render: h => h(App),
      i18n,
      methods: {
        displayNotificationMsg(msg, alerttype) {
          return this.$children[0].displayNotificationMsg(msg, alerttype)
        }
      },
    }).$mount('#app')
})

